import Header from "./components/Header";
import UpdateStrip from "./components/UpdateStrip";
import Hero from "./components/Hero";
import Entrance from "./components/Entrance";
import FeatureHot from "./components/FeatureHot";
import Boards from "./components/Boards";
import Talk from "./components/Talk";
import FollowBand from "./components/FollowBand";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Header />
      <main className="flex-1">
        <UpdateStrip />
        <Hero />
        <Entrance />
        <FeatureHot />
        <Boards />
        <Talk />
        <FollowBand />
      </main>
      <Footer />
    </div>
  );
}